import { Box } from '@material-ui/core';
import { postCreateMerchant } from '@nemuru-eng/js-api-client';
import React, { Dispatch, SetStateAction } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { CreateMerchantForm } from '@/components/widgets/MerchantListActions/components/CreateMerchantForm';
import {
  MerchantCreationSchema,
  MerchantCreationType,
} from '@/components/widgets/MerchantListActions/schemas/MerchantCreationSchema';
import { useRequest } from '@/hooks/requests/useRequest';
import { forceRefreshDataGridTable } from '@/utils/forceRefreshDataGridTable';

export const CreateMerchantDialog: React.FC<{
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
}> = ({ opened, setOpened, toggleDialog }) => {
  const { request, loading } = useRequest();

  const onSubmitForm = async (useFormValues: MerchantCreationType) => {
    const { phoneNumber, dialCode, ...formValues } = useFormValues;
    await request(postCreateMerchant, {
      id: uuidv4(),
      ...formValues,
      merchantPhoneNumber: `+${dialCode.dialCode}${phoneNumber}`,
    });
    forceRefreshDataGridTable();
    toggleDialog();
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'CREATE_MERCHANT'}
      onSubmitForm={onSubmitForm}
      saveButtonTextId={'ADD_MERCHANT'}
      isLoading={loading}
      formSchema={MerchantCreationSchema}
    >
      <Box pt={2}>
        <CreateMerchantForm fieldVariant={FieldVariant.form} fullWidth />
      </Box>
    </EditDialogWrapper>
  );
};
